export const OWN_SUPPLIERS_QUERY = '/own-critical-suppliers';
export const OWN_UNCONFIRMED_SUPPLIERS_QUERY = '/own-critical-suppliers/unconfirmed';
export const CONNECT_TO_SUPPLIER_QUERY = '/orgs/:orgId/critical-supplier-connection';
